/**
 * WordPress dependencies
 */
import { Button, Dropdown, ColorPalette, RangeControl, SelectControl, BaseControl } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
/**
 * External dependencies
 */
import classnames from 'classnames';

const BoxShadowControl = ( { className, contentClassName, position, value = {}, onChange, label } ) => {
	const isActive = value?.color || value?.horizontal || value?.vertical || value?.blur || value?.spread || value?.position;
	return <div className="gutenify--box-shadow-control">
		<label htmlFor="field-101">
			<span>{ label }</span>
			<Dropdown
				headerTitle={ __( 'Box Shadow' ) }
				id="field-101"
				className={ className }
				contentClassName={ classnames( contentClassName, 'gutenify--box-shadow-control-content' ) }
				position={ position }
				renderToggle={ ( { isOpen, onToggle } ) => (
					<Button
						onClick={ onToggle }
						aria-expanded={ isOpen }
						icon="admin-customizer"
						variant="secondary"
						className={ classnames( 'gutenify--box-shadow-control--button', ( isActive || isOpen ) && 'gutenify--box-shadow-control--button--active' ) }
					>

					</Button>
				) }
				renderContent={ () => <div>
					<BaseControl
						label={ __( 'Color' ) }
						id="arrow-styles"
					>
						<ColorPalette
							label={ __( 'Color' ) }
							colors={ [] }
							value={ value?.color ? value?.color : '#000000' }
							onChange={ ( val ) => {
								onChange( {
									...value,
									color: val,
								} );
							} }
						/>
					</BaseControl>
					<RangeControl
						label={ __( 'Horizontal (PX)' ) }
						value={ value?.horizontal ? value?.horizontal : 0 }
						onChange={ ( val ) => {
							onChange( {
								...value,
								horizontal: val,
							} );
						} }
						min={ -100 }
						max={ 100 }
					/>
					<RangeControl
						label={ __( 'Vertical (PX)' ) }
						value={ value?.vertical ? value?.vertical : 0 }
						onChange={ ( val ) => {
							onChange( {
								...value,
								vertical: val,
							} );
						} }
						min={ -100 }
						max={ 100 }
					/>
					<RangeControl
						label={ __( 'Blur (PX)' ) }
						value={ value?.blur ? value?.blur : 0 }
						onChange={ ( val ) => {
							onChange( {
								...value,
								blur: val,
							} );
						} }
						min={ 0 }
						max={ 100 }
					/>
					<RangeControl
						label={ __( 'Spread (PX)' ) }
						value={ value?.spread ? value?.spread : 0 }
						onChange={ ( val ) => {
							onChange( {
								...value,
								spread: val,
							} );
						} }
						min={ -100 }
						max={ 100 }
					/>
					<SelectControl
						label={ __( 'Position' ) }
						value={ value?.position ? value?.position : 'outline' } // e.g: value = [ 'a', 'c' ]
						onChange={ ( val ) => {
							onChange( {
								...value,
								position: val,
							} );
						} }
						options={ [
							{ value: 'outline', label: __( 'Outline' ) },
							{ value: 'inset', label: __( 'Inset' ) },
						] }
					/>
				</div> }
			/>
		</label>
	</div>
	;
};

export default BoxShadowControl;
